export default __webpack_public_path__ + "static/media/rifat.608bdea9.jpg";